import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { ComponentBase, DbaDataTableColumn, DbaMAtTableDatatypesEnum, DialogData } from '@definitiv-packages/angular-dba-library';
import { AppService, DebitorModel, DebitorService, ObjektModelView, ObjektViewService, ProjectLanguage, ProjektPermissionService, RoofareaModelView, RoofareaService, RoofAreaView, RoofareaViewService, StandortModel, StandortService } from '../../../../../roofsafetymanagement-library/src/public-api';
import { CreateRoofareaComponent } from '../../../../../roofsafetymanagement-library/src/lib/dialogs/create-roofarea/create-roofarea.component';

@Component({
  selector: 'app-roofarea-main-view',
  templateUrl: './roofarea-main-view.component.html',
  styleUrls: ['./roofarea-main-view.component.scss'],
  standalone: false
})
export class RoofareaMainViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {  public isAdmin: boolean = false;
  public isAppAdmin: boolean = false;
  public roofareaList: RoofareaModelView[] = [];

  public objektList: ObjektModelView[] = [];
  public selectedObjekt: ObjektModelView = {};
  public objektfilteredList : ObjektModelView[] = [];
  public selectedRoofarea: RoofareaModelView | null = null;
  public enablecreatebutton: boolean = false;
  public debitorList: DebitorModel[] = [];
  public selectedDebitor: DebitorModel = new DebitorModel();
  public standortList: StandortModel[] = [];
  public standortfilteredList: StandortModel[] = [];
  public selectedStandort: StandortModel= new StandortModel();
  public columnsdefMain: DbaDataTableColumn<RoofareaModelView, ProjectLanguage>[] = [
    { id: 'Debitorname', label: 'debitor', hideOrder: 8 },
    { id: 'StandortBezeichnung', label: 'Standort', hideOrder: 9 },    
    { id: 'ObjektBezeichnung', label: 'objektbezeichnung', hideOrder: 1 },
    { id: 'Bezeichnung', label: 'roofarea', hideOrder: 0 },
    { id: 'Strasse', label: 'Strasse', hideOrder: 2 },
    { id: 'PLZ', label: 'PLZ', hideOrder: 3, width: 100 },
    { id: 'Ort', label: 'Ort', hideOrder:4 , width: 100 },
    { id: 'LandName', label: 'Land', hideOrder: 5 , width: 100 },
  ];


  constructor(
    public permissionService: ProjektPermissionService,
    private roofareaViewService: RoofareaViewService,
    private roofareaService: RoofareaService,
    private objektService: ObjektViewService,
    private debitorService: DebitorService,    
    private standortService: StandortService,    
    private appService: AppService,
    private dialog: MatDialog,
  ) { super(); }

  public async ngOnInit() {
      
      this.isAdmin = this.appService.isUserAdmin();
      this.isAppAdmin = this.appService.isAppAdmin();

      this.loading = true;
      await this.getDebitorList();
      await this.getStandortList();
      await this.getObjektList();
      await this.getRoofareaList();

      this.loading = false;
  }

  public async getDebitorList() {

      try {
        var result = await Promise.all([this.debitorService.getList()]);      
        this.debitorList = result[0].sort((a, b) =>
          (a.Name || '').localeCompare(b.Name || '')
        );
      } catch {
      }
      
      let alle : DebitorModel = new DebitorModel();
      alle.DebitorID = 0;
      alle.Name = "alle";
      this.debitorList.unshift(alle);
      this.selectedDebitor = this.debitorList[0];
  }
  
  public async getStandortList() {
      
      try {
        var result = await Promise.all([this.standortService.getList()]);      
        this.standortList = result[0].sort((a, b) =>
          (a.Bezeichnung || '').localeCompare(b.Bezeichnung || '')
        );
      } catch {
      }
    
      let alle : StandortModel = new StandortModel();
          
      alle.StandortID = 0;
      alle.Bezeichnung = "alle";
      this.standortList.unshift(alle);
      this.selectedStandort = this.standortList[0];
      this.standortfilteredList = this.standortList;
  }

  public async getObjektList() {
    this.loading = true;

    try {
      var result = await Promise.all([this.objektService.getList()]);
      this.objektList = result[0].sort((a, b) =>
        (a.Bezeichnung || '').localeCompare(b.Bezeichnung || '')
      );
    } catch {
    }
    var alle : ObjektModelView ={
        ObjektID : 0,
        Bezeichnung : "alle"
    }
    
    alle.Bezeichnung = "alle";

    this.objektList.unshift(alle);
    this.selectedObjekt = this.objektList[0];
    this.objektfilteredList = this.objektList;
  };

  public async getRoofareaList() {
    try {
      var result = await Promise.all([this.roofareaViewService.getList()]);

      this.roofareaList = result[0];
    } catch {
    }
  }

  // public DeleteDataMain(selected: (Personal | null)[]): void {
  //   BuildDeleteDataPromise<Personal | null>(selected, (element) => { return this.PersonalService.DeletePersonal(element!) }).then(() => this.getPersonalList());
  // };


    public debitorFilter = (list: RoofareaModelView[], filter: DebitorModel): RoofareaModelView[] => {
      if (filter.DebitorID == undefined || filter.DebitorID == 0)
        return list;
      else
        return list.filter(x => x.DebitorID == filter.DebitorID);
    }    

    public standortFilter = (list: RoofareaModelView[], filter: StandortModel): RoofareaModelView[] => {
      if (filter.StandortID == undefined || filter.StandortID == 0)
        return list;
      else
        return list.filter(x => x.StandortID == filter.StandortID);
    }    
    public async OpenDialog(data: DialogData<RoofareaModelView>): Promise<void> {
      if (!this.permissionService.RoofareaSchreiben) return;

      var roofarea = await firstValueFrom(this.dialog.open(CreateRoofareaComponent, { data: data }).afterClosed());

      if (!roofarea)
        return

      var changedroofarea = await this.roofareaViewService.get(roofarea.RoofareaID)

      this.selectedRoofarea = null;

      if (data.mode == 'create' || data.mode == 'copy')
        this.roofareaList.push(changedroofarea);
      else if (data.mode == 'edit') {
        var index = this.roofareaList.findIndex(x => x.RoofareaID == roofarea.RoofareaId);
        if (index != -1)
          this.roofareaList[index] = changedroofarea;
      }
      
      await this.getRoofareaList();
      this.selectedRoofarea = changedroofarea;
    }

    public objektFilter = (list: RoofareaModelView[], filter: ObjektModelView): RoofareaModelView[] => {
        if (filter.ObjektID == undefined || filter.ObjektID == 0)
          return list;
        else
          return list.filter(x => x.ObjektID == filter.ObjektID);
    }

    public async deleteData(roofarea: RoofareaModelView[]) {
        this.loading = true;
        await this.roofareaService.delete(roofarea[0].RoofareaID!);
        await this.getRoofareaList();
        this.loading = false;      
    }  
    public filterStandort() {

        if (this.selectedDebitor?.DebitorID == 0) {
          this.standortfilteredList = this.standortList;    
        }
        else {
            this.standortfilteredList = this.standortList.filter(x => x.DebitorID == this.selectedDebitor?.DebitorID || x.DebitorID == 0)       
            this.selectedStandort = this.standortfilteredList[0];  
        }
        
        this.filterObjekte();
    }    
   public filterObjekte() {
        
        this.objektfilteredList = this.objektList;        
        if (this.selectedDebitor?.DebitorID) {

            this.objektfilteredList = this.objektfilteredList.filter(x=>x.DebitorID == this.selectedDebitor?.DebitorID || x.ObjektID == 0)
        }
        if (this.selectedStandort?.StandortID) {
            this.objektfilteredList = this.objektfilteredList.filter(x=>x.StandortID == this.selectedStandort?.StandortID || x.ObjektID == 0)
        }
        if(!this.selectedDebitor?.DebitorID && !this.selectedStandort?.StandortID){
            this.selectedObjekt  = this.objektfilteredList[0];
        }
    }        

}
